import { vehicles } from "@/api/vehicle/useVehicleQuery";
import { DetailContainer } from "@/features/standard/detail/Container";
import { DetailContent } from "@/features/standard/detail/Content";
import { DetailWrapper } from "@/features/standard/detail/Wrapper";
import { Main } from "@/features/standard/Main";
import { useQuery } from "@tanstack/react-query";
import { VehicleDetailHeader } from "../header/DetailHeader";

const Detail = Object.assign(Main, {
  Container: DetailContainer,
  Wrapper: DetailWrapper,
  Content: DetailContent,
});

interface VehicleDetailFormProps {
  code?: string;
}

export const VehicleDetailForm = (params: VehicleDetailFormProps) => {
  const { code } = params;

  const { data } = useQuery({
    ...vehicles.get({
      query: { $and: [{ code: { $eq: code } }] },
    }),
    enabled: !!code,
  });
  return (
    <Detail.Container>
      <Detail.Wrapper>
        <Detail.Content>
          <VehicleDetailHeader data={data} />
        </Detail.Content>
      </Detail.Wrapper>
    </Detail.Container>
  );
};
